import { getMemberListService } from "@/helpers/service/api/membership";
import { priceFormatter, getMemberStatus } from "@/assets/js/membership";
import { json2csv_fn } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";

export function exportCSV_fn(requestParma, originMemberTypeList, memberTypeList) {
  function getRankName(id, memberShipId) {
    const curRankList = (originMemberTypeList.find(item => item.id === memberShipId) || {}).rankList;
    return curRankList && curRankList.length > 0 ? (curRankList.find(rank => rank.uuid === id) || {}).name : "";
  }
  getMemberListService(requestParma).then(res => {
    let csvData = [];
    const fields = [
      {
        label: locale("membership.coupon.memberID"),
        value: "memberNum"
      },
      {
        label: locale("global.name"),
        value: "chineseFullName"
      },
      {
        label: locale("global.email"),
        value: "email"
      },
      {
        label: locale("membership.coupon.memberType"),
        value: "memberShipName"
      },
      {
        label: locale("membership.coupon.rank"),
        value: "memberShipRankName"
      },
      {
        label: locale("membership.memberList.viewNumbers"),
        value: "totalViews"
      },
      {
        label: locale("membership.coupon.consumption"),
        value: "totalCost"
      },
      {
        label: locale("membership.memberList.upgradesLeft"),
        value: "needMoreViews"
      },
      {
        label: locale("membership.coupon.enrollmentDate"),
        value: "joinTime"
      },
      {
        label: locale("couponLib.expiredDate"),
        value: "expireTime"
      },
      {
        label: locale("membership.memberList.status"),
        value: "memberStatusText"
      },
    ];
    const includeAddress = requestParma.includeAddress === true;
    if (res.data && res.data.data.length > 0) {
      if (includeAddress) {
        fields.push(
          {
            label: "郵便番号",
            value: "postalCode"
          },
          {
            label: "住所",
            value: "fullAddress"
          }
        );
      }
      res.data.data.forEach(item => {
        const {
          memberNum, chineseFullName, memberShipId, memberShipRankId, totalCost,
          joinTime, expireTime, memberStatus, email, totalViews, needMoreViews,
        } = item;
        const row = {
          memberNum,
          chineseFullName,
          email,
          memberShipName: (memberTypeList.find(item => item.value === memberShipId) || {}).text,
          memberShipRankName: getRankName(memberShipRankId, memberShipId),
          totalViews: (totalViews !== null && totalViews !== undefined) ? totalViews.toLocaleString() : "",
          totalCost: (totalCost !== null && totalCost !== undefined) ? totalCost.toLocaleString() : "",
          needMoreViews: (needMoreViews !== null && needMoreViews !== undefined) ? needMoreViews.toLocaleString() : "",
          joinTime: moment(joinTime).format("YYYY/MM/DD"),
          expireTime: moment(expireTime).format("YYYY/MM/DD"),
          memberStatusText: (getMemberStatus().find(item => item.value === memberStatus) || {}).text
        };
        if (includeAddress) {
          row.postalCode = item.postalCode || "";
          row.fullAddress = [item.prefecture, item.city, item.address].filter(Boolean).join("");
        }
        csvData.push(row);
      });
      json2csv_fn(csvData, fields, moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.memberList"));
    }
  });
}